<template>
	<v-btn rounded color="primary" @click="click($event)">
		<v-icon left>fa-save</v-icon>
		{{ $t('common.save') }}
	</v-btn>
</template>

<script>
export default {
	name: 'SaveButton',
	methods: {
		click(event) {
			this.$emit('click', event);
		}
	}
};
</script>